/**
 * Конфигурация и константы для функции поиска по координатам
 */

export const COORDINATE_SEARCH_STYLES = {
    // Размеры и отступы
    HINT_HEIGHT: 36,
    LABEL_PADDING: '12px 16px 12px 35px',
    LABEL_GAP: '12px',
    ICON_GAP: '8px',

    // Поиск подсказка
    SEARCH_HINT: {
        background: 'rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(2px)',
        fontWeight: 400,
        textColor: '#333',
        fontSize: '12px',
        zIndex: 1000,
    },

    // Закреплённая подсказка
    PINNED_HINT: {
        background: '#f5f5f5',
        fontWeight: 400,
        textColor: '#333',
        fontSize: '12px',
    },

    // Иконки
    ICON: {
        width: 16,
        height: 16,
        color: '#333',
        strokeWidth: 2,
    },

    // Маркеры на карте
    MARKER: {
        radius: 6,
        color: '#3b82f6',
        opacity: 0.8,
        strokeWidth: 2,
        strokeColor: '#ffffff',
    },

    // Лейбл на карте
    LABEL: {
        fontSize: 14,
        offsetX: 0.6,
        offsetY: -0.6,
        textColor: '#ffffff',
        font: 'Open Sans Regular',
    },
};

export const COORDINATE_SEARCH_MESSAGES = {
    NAVIGATE: 'Перейти к координатам',
    POINT_PREFIX: 'Точка',
};

export const COORDINATE_SEARCH_MAP_CONFIG = {
    DEFAULT_ZOOM: 15,
    DEFAULT_ANIMATE: false,
};

// SVG иконки
export const COORDINATE_SEARCH_ICONS = {
    ARROW: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #333; flex-shrink: 0;">
        <path d="M5 12h14M12 5l7 7-7 7"></path>
    </svg>`,
    DELETE: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #333; flex-shrink: 0;">
        <path d="M18 6L6 18M6 6l12 12"></path>
    </svg>`,
};

/**
 * Генератор стилей для подсказки поиска
 */
export const generateSearchHintStyles = () => {
    const style = COORDINATE_SEARCH_STYLES.SEARCH_HINT;
    return `
        padding: ${COORDINATE_SEARCH_STYLES.LABEL_PADDING};
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: ${COORDINATE_SEARCH_STYLES.LABEL_GAP};
        height: 100%;
        background: ${style.background};
        backdrop-filter: ${style.backdropFilter};
        z-index: ${style.zIndex};
        box-sizing: border-box;
    `;
};

/**
 * Генератор стилей для закреплённой подсказки
 */
export const generatePinnedHintStyles = () => {
    const style = COORDINATE_SEARCH_STYLES.PINNED_HINT;
    return `
        padding: ${COORDINATE_SEARCH_STYLES.LABEL_PADDING};
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: ${COORDINATE_SEARCH_STYLES.LABEL_GAP};
        height: 100%;
        background: ${style.background};
        box-sizing: border-box;
    `;
};

/**
 * Генератор стилей для текста координат
 */
export const generateCoordinatesTextStyles = () => {
    const style = COORDINATE_SEARCH_STYLES.SEARCH_HINT;
    return `font-weight: ${style.fontWeight}; color: ${style.textColor};`;
};

/**
 * Генератор стилей для текста действия (навигация/удаление)
 */
export const generateActionTextStyles = () => {
    const style = COORDINATE_SEARCH_STYLES.SEARCH_HINT;
    return `font-size: ${style.fontSize}; color: ${style.textColor}; white-space: nowrap;`;
};

/**
 * Генератор стилей для контейнера действий (навигация/удаление + иконка)
 */
export const generateActionContainerStyles = () => {
    return `display: flex; align-items: center; gap: ${COORDINATE_SEARCH_STYLES.ICON_GAP};`;
};
